
import React from 'react'
import Header from '../Header/header'

function HeroSection() {
  return (
    <div className='w-full flex flex-col max-w-[400px] justify-center items-center gap-3 pb-2 mt-3'>
        {/* <img src='/assets/img/Footer logo.png' alt='digitmoney logo' loading='lazy' className='w-[142px] h-[24px]'/> */}
        
        <img src='/assets/img/Group 307 (1).png' loading='lazy' className=' w-[255px] h-[75px]'/>
        
        <h2 className='text-[30px] font-polysans-Median text-center'>Get Personal Loan <br/>Offers in Minutes</h2>
        <p className='font-atkinson text-center leading-[1.1] text-[14px] text-[#558075]'>Instant approval, low interest rates, fully <br/> digital journey</p>
        
        <div className='w-[46px] h-[4px] bg-gradient-to-r from-[#12F280] to-[#1B1B1B] rounded-[4px] mt-1'/>
      
    </div>
  )
}

export default HeroSection
